import { css } from 'lit';

export const roundButtonOnDarkStyles = css`

  --_round-button__color: var(--sbkRoundButtonBgColorOnLightEnabled);
  --_round-button__color--active: var(--sbkRoundButtonBgColorOnDarkEnabled);
  --_round-button__color--hover: var(--sbkRoundButtonFgColorOnDarkDefault);
  --_round-button__color--focus: var(--sbkRoundButtonBgColorOnLightEnabled);
  --_round-button__color--disabled: var(--sbkRoundButtonFgColorOnLightDisabled);
  --_round-button__color--error: var(--sbkRoundButtonFgColorOnDarkDefault);
  --_round-button-icon-only__color: var(--sbkRoundButtonBgColorOnDarkEnabled);

  --_round-button__bg: var(--sbkRoundButtonBgColorOnDarkEnabled);
  --_round-button__bg--active: var(--sbkRoundButtonBgColorOnDarkActive);
  --_round-button__bg--hover: var(--sbkRoundButtonBgColorOnDarkHover);
  --_round-button__bg--focus: var(--sbkRoundButtonBgColorOnDarkFocus);
  --_round-button__bg--disabled: var(--sbkRoundButtonBgColorOnDarkDisabled);
  --_round-button__bg--error: var(--sbkRoundButtonBgColorOnDarkError);
  --_round-button-icon-only__bg: var(--sbkRoundButtonBgColorOnDarkEnabledTransparent);

  --_round-button__border-color: var(--sbkRoundButtonBorderOnDarkMarked);
  --_round-button__border-color--active: var(--sbkButtonBorderOnDarkActive);
  --_round-button__border-color--hover: var(--sbkButtonBorderOnDarkHover);
  --_round-button__border-color--focus: var(--sbkButtonBorderOnDarkFocus);
  --_secondary-button__border-color--disabled: var(--sbkButtonBorderOnDarkDisabled);
  --_secondary-button__border-color--error: var(--sbkButtonBorderOnDarkDisabled);
`